import './bootstrap';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { cssVariables } from './theme/cssVars';
import './theme/global.css';
import { captureReferral } from './state/referral';
import { rewriteCreatorLink } from './journey/creatorLinks';

// A creator's /go/<audience>/<handle> becomes the demo-first journey, before anything reads the address.
rewriteCreatorLink();
// "Make yours" from a published page (2026-11-01): read before the router can redirect the address away.
captureReferral();

// One source for design values: the app's own token module, emitted as custom properties
// before the first paint so global.css and every component read the same numbers.
const vars = document.createElement('style');
vars.textContent = cssVariables();
document.head.prepend(vars);

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
